/** Shared constraints for the scanned, hand-signed file uploaded to wet-ink verification (guide §8). */
export const ACCEPTED_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
export const MAX_BYTES = 10 * 1024 * 1024; // 10MB

/** Validate a chosen scan against the upload constraints. Returns an error message, or null if OK. */
export const validateScan = (file: File): string | null => {
  if (!ACCEPTED_TYPES.includes(file.type)) {
    return 'Unsupported file type. Upload a PDF, JPEG, or PNG.';
  }
  if (file.size > MAX_BYTES) {
    return 'File exceeds the 10MB limit.';
  }
  return null;
};
